// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/assay_metadata.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "../../../../google/protobuf/timestamp_pb";
import { file_google_protobuf_timestamp } from "../../../../google/protobuf/timestamp_pb";
import { file_quanterix_common_extensions_v1_field_options } from "../../../common/extensions/v1/field_options_pb";
import type { AssayType } from "../../../common/types/v1/assay_type_pb";
import { file_quanterix_common_types_v1_assay_type } from "../../../common/types/v1/assay_type_pb";
import type { ResourceStatus } from "./resource_status_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_resource_status } from "./resource_status_pb";
import type { User } from "./user_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_user } from "./user_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/assay_metadata.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_assay_metadata: GenFile = /*@__PURE__*/
  fileDesc("CjxxdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvYXNzYXlfbWV0YWRhdGEucHJvdG8SJ3F1YW50ZXJpeC5zaW1vYV9vbmUuYW5hbHlzaXNfYXBwX2FwaS52MSL+BAoNQXNzYXlNZXRhZGF0YRIfCghhc3NheV9pZBgBIAEoCUIIgrUYBBgBIAFIAIgBARIXCgphc3NheV9uYW1lGAIgASgJSAGIAQESPQoKYXNzYXlfdHlwZRgDIAEoDjIkLnF1YW50ZXJpeC5jb21tb24udHlwZXMudjEuQXNzYXlUeXBlSAKIAQESOgoRY3JlYXRlZF90aW1lc3RhbXAYBCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSAOIAQESOwoSbW9kaWZpZWRfdGltZXN0YW1wGAUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgEiAEBEkYKCmNyZWF0ZWRfYnkYBiABKAsyLS5xdWFudGVyaXguc2ltb2Ffb25lLmFuYWx5c2lzX2FwcF9hcGkudjEuVXNlckgFiAEBEkwKEGxhc3RfbW9kaWZpZWRfYnkYByABKAsyLS5xdWFudGVyaXguc2ltb2Ffb25lLmFuYWx5c2lzX2FwcF9hcGkudjEuVXNlckgGiAEBEkwKBnN0YXR1cxgIIAEoDjI3LnF1YW50ZXJpeC5zaW1vYV9vbmUuYW5hbHlzaXNfYXBwX2FwaS52MS5SZXNvdXJjZVN0YXR1c0gHiAEBEhAKCHBsZXhfaWRzGAkgAygJQgsKCV9hc3NheV9pZEINCgtfYXNzYXlfbmFtZUINCgtfYXNzYXlfdHlwZUIUChJfY3JlYXRlZF90aW1lc3RhbXBCFQoTX21vZGlmaWVkX3RpbWVzdGFtcEINCgtfY3JlYXRlZF9ieUITChFfbGFzdF9tb2RpZmllZF9ieUIJCgdfc3RhdHVzYgZwcm90bzM", [file_google_protobuf_timestamp, file_quanterix_common_extensions_v1_field_options, file_quanterix_common_types_v1_assay_type, file_quanterix_simoa_one_analysis_app_api_v1_resource_status, file_quanterix_simoa_one_analysis_app_api_v1_user]);

/**
 * Contains metadata describing an assay
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.AssayMetadata
 */
export type AssayMetadata = Message<"quanterix.simoa_one.analysis_app_api.v1.AssayMetadata"> & {
  /**
   * Unique identifier (UUID)
   *
   * For backward-compatibility with existing "Protocol" and "Definition"
   * assay messages, this field should be mapped to `*_protocol_id`
   *
   * @generated from field: optional string assay_id = 1;
   */
  assayId?: string;

  /**
   * User-friendly assay name
   *
   * @generated from field: optional string assay_name = 2;
   */
  assayName?: string;

  /**
   * Specifies the assay type
   *
   * @generated from field: optional quanterix.common.types.v1.AssayType assay_type = 3;
   */
  assayType?: AssayType;

  /**
   * Represents the point in time at which the assay was created,
   * independent of timezone
   *
   * @generated from field: optional google.protobuf.Timestamp created_timestamp = 4;
   */
  createdTimestamp?: Timestamp;

  /**
   * Represents the point in time at which the assay was last modified,
   * independent of timezone
   *
   * @generated from field: optional google.protobuf.Timestamp modified_timestamp = 5;
   */
  modifiedTimestamp?: Timestamp;

  /**
   * Represents the identity of the user who created the assay
   *
   * @generated from field: optional quanterix.simoa_one.analysis_app_api.v1.User created_by = 6;
   */
  createdBy?: User;

  /**
   * Represents the identity of the user who last modified the assay
   *
   * @generated from field: optional quanterix.simoa_one.analysis_app_api.v1.User last_modified_by = 7;
   */
  lastModifiedBy?: User;

  /**
   * State of the assay resource (e.g. in draft, locked, etc.)
   *
   * @generated from field: optional quanterix.simoa_one.analysis_app_api.v1.ResourceStatus status = 8;
   */
  status?: ResourceStatus;

  /**
   * Unique identifiers (UUID) for plexes referenced by this assay
   *
   * @generated from field: repeated string plex_ids = 9;
   */
  plexIds: string[];
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.AssayMetadata.
 * Use `create(AssayMetadataSchema)` to create a new message.
 */
export const AssayMetadataSchema: GenMessage<AssayMetadata> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_assay_metadata, 0);

